<script>
  import LightboxViewer from './lightbox_viewer.svelte'

  let { url, thumbnailUrl, title = '', thumbClass = 'h-24 w-24 object-contain bg-base-200 rounded-box', buttonClass = '', items } = $props()

  let open = $state(false)
  let index = $state(0)
  let failed = $state(false)

  // Reset the failure flag when the instance is reused with a new poster.
  $effect(() => {
    thumbnailUrl
    failed = false
  })

  const gallery = $derived(items || [{ type: 'video', url, title }])

  const show = () => {
    index = items ? items.findIndex((item) => item.url === url) : 0
    if (index < 0) index = 0
    open = true
  }
</script>

<!-- design-lint-disable no-raw-color (white play glyph sits over media, not a themed surface) -->
<button type="button" class="relative cursor-zoom-in p-0 border-0 bg-transparent {buttonClass}" onclick={show}>
  {#if thumbnailUrl && !failed}
    <img src={thumbnailUrl} alt={title} class={thumbClass} onerror={() => (failed = true)} />
  {:else}
    <div class="{thumbClass} bg-base-300 flex items-center justify-center">▶</div>
  {/if}
  <span class="absolute inset-0 flex items-center justify-center text-white text-2xl drop-shadow">▶</span>
</button>

<LightboxViewer bind:open items={gallery} bind:index />
